import { render, staticRenderFns } from "./OverdueSalesTable.vue?vue&type=template&id=b8dce0a2&scoped=true&"
import script from "./OverdueSalesTable.vue?vue&type=script&lang=ts&"
export * from "./OverdueSalesTable.vue?vue&type=script&lang=ts&"
import style0 from "./OverdueSalesTable.vue?vue&type=style&index=0&id=b8dce0a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../backups/absys-worktrees/2026-09-12-colomer-web/src/web/AbsysERP.WebApi/ClientApp/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8dce0a2",
  null
  
)

export default component.exports